/**
 * @name BuiltinRepositoryOptions
 * @type {Object}
 * @property {string} type
 * @property {String} search_api
 */

/**
 * マップアプリ既定のAPI（Postgresql）からデータ取得するためのデータベースアクセサ
 * 
 * TODO: 動作未確認
 * @name BuiltinRepository
 * @extends {Repository}
 */
export default class BuiltinRepository {
  /**
   * 
   * @param options
   */
  constructor(options) {
    this.events = null;
    this.options = options;
  }
  setEvents(events) {
    this.events = events;
  }
  search(request) {
    
    var that = this;

    // 円表示なしの場合は、全て検索対象にする
    if (request.radius === '0' || request.radius === '' || request.radius === 0){
      request.radius = 100;
    }
    /**
     * 検索対象となっている施設の番号を得る
     * 形式：ハイフン区切り（ex. 1-2-3）
     */
    request.search_url = this.options.searchApi + '?' + request.toQueryString();

    this.events.emit('ihBeforeSearch', request);

    // タイプが空の場合は施設を返さない
    if (request.type === '' || (request.get('types') && request.get('types').length === 0)) {
      return Promise.resolve({"places": []});
    }
    
    return new Promise((resolve, reject) => {
      
      var ajaxParams = {
        url: request.search_url,
        dataType: "json"
      };
      var that = this;
      // Ajax通信開始
      $.ajax(ajaxParams)
        // .pipe(function(json){
        //   // // タイムスロットの拡張を行う。
        //   // // TODO: IHCoursesがIHTimeSlot依存になるので、検索直後にイベント設定できるようにして
        //   // // IHTimeSlotからリスナー追加した方が良さそう
        //   // if (that.extendPlacesForTimeslot){
        //   //   json.places = that.extendPlacesForTimeslot(json.places);
        //   // }
        //   // // ------------------------------------
        //   // // filter
        //   // if (json && json.places){
        //   //   for (var i = 0; i < json.places.length; i++){
        //   //     json.places[i] = that.placeDataFilter(json.places[i]);
        //   //   }
        //   // }
        //   // return json;
        // })
        .done(function(response){
          that.events.emit('ihAfterSearch', request, response);
          resolve(response);
        })
        .fail(function(){
          alert('エラーが発生しました');
          reject();
        });


    });
    
  }
}



// WEBPACK FOOTER //
// ./map/js/ih/repository/BuiltinRepository.js